import styled from 'styled-components/macro';
import * as colors from '../../../common/colorConstants';
import { NextButton } from '../../../common/buttonsComponents';

export const SearchContainer = styled.div`
  background-color: ${colors.lightGray7};
  padding: 30px;
  display: flex;
`;

export const SearchField = styled.input`
  max-width: 190px;
  width: 100%;
  padding: 4px 10px;
  margin-right: 12px;
  outline: none;
  background: ${colors.white};
  border-radius: 4px;
  border: 1px solid ${colors.lightGray21};
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 11px;
  color: ${colors.darkGray1};
`;

export const SearchResultContainer = styled.div``;

export const SearchResultHeader = styled.p`
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 10px;
  margin: 20px 30px;
  color: ${colors.darkGray1};
  text-transform: uppercase;
`;
export const SearchResultHead = styled.div`
  padding: 5px 30px;
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 9px;
  line-height: 18px;
  background-color: ${colors.lightGray7};
  text-transform: uppercase;
  color: ${colors.darkGray14};
`;

export const SearchResultRow = styled.div`
  display: flex;
  padding: 10px 30px;
  border-bottom: 1px solid ${colors.lightGray15};
  font-family: 'Roboto', sans-serif;
  color: ${colors.black4};
`;

export const SearchResultTitle = styled.div`
  max-width: 120px;
  width: 100%;
  font-weight: 500;
  font-size: 11px;
`;

export const SearchResultValue = styled.div`
  font-size: 11px;
`;

export const Button = styled(NextButton)`
  float: none;
  margin-top: 30px;
  margin-left: 30px;
`;
